import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";

const CATS = ["Music Video", "Film", "OTT", "Advertisement", "Fashion", "Editorial", "Brand Campaign", "Event", "Other"];

const BLANK = { project: "", role: "", shoot_date: "", location: "", budget: "", usage: "", requirements: "", message: "", category: "Music Video" };

export default function AdminCastingCallsTab() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState(BLANK);
  const [busy, setBusy] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const load = () => api.get("/admin/casting-calls").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const set = (k, v) => setF({ ...f, [k]: v });

  const create = async () => {
    if (!f.project || !f.role) { toast.error("Project and Role required"); return; }
    setBusy(true);
    try { await api.post("/casting-calls", f); toast.success("Casting call published"); setF(BLANK); setShowForm(false); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not create"); }
    setBusy(false);
  };

  const close = async (id, status) => {
    await api.post("/admin/casting-calls/update", { casting_id: id, status });
    toast.success(`Marked ${status}`); load();
  };
  const del = async (id) => {
    if (!window.confirm("Delete this casting call?")) return;
    await api.delete(`/admin/casting-calls/${id}`); toast.success("Deleted"); load();
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div className="text-xs text-[#8A8478]">{items.length} casting calls</div>
        <button onClick={() => setShowForm(!showForm)} data-testid="add-casting" className="sv-btn-primary inline-flex items-center gap-2">
          <Plus size={14} />{showForm ? "Cancel" : "Add Casting Call"}
        </button>
      </div>

      {showForm && (
        <div className="sv-card p-6 grid md:grid-cols-2 gap-3">
          <input required placeholder="Project Name *" className="sv-input" value={f.project} onChange={(e) => set("project", e.target.value)} data-testid="cc-project" />
          <input required placeholder="Role *" className="sv-input" value={f.role} onChange={(e) => set("role", e.target.value)} data-testid="cc-role" />
          <select className="sv-select" value={f.category} onChange={(e) => set("category", e.target.value)}>
            {CATS.map((c) => <option key={c}>{c}</option>)}
          </select>
          <input placeholder="Location" className="sv-input" value={f.location} onChange={(e) => set("location", e.target.value)} />
          <input placeholder="Shoot Date (YYYY-MM-DD)" className="sv-input" value={f.shoot_date} onChange={(e) => set("shoot_date", e.target.value)} />
          <input placeholder="Budget / Rate" className="sv-input" value={f.budget} onChange={(e) => set("budget", e.target.value)} />
          <input placeholder="Usage (Digital / Print / TVC…)" className="sv-input md:col-span-2" value={f.usage} onChange={(e) => set("usage", e.target.value)} />
          <textarea rows={3} placeholder="Requirements" className="sv-input md:col-span-2" value={f.requirements} onChange={(e) => set("requirements", e.target.value)} />
          <textarea rows={3} placeholder="Message / Brief" className="sv-input md:col-span-2" value={f.message} onChange={(e) => set("message", e.target.value)} />
          <div className="md:col-span-2 flex justify-end gap-2">
            <button onClick={() => setShowForm(false)} className="sv-btn-outline">Cancel</button>
            <button onClick={create} disabled={busy} data-testid="cc-save" className="sv-btn-primary">{busy ? "Publishing…" : "Publish Casting Call"}</button>
          </div>
        </div>
      )}

      <div className="space-y-3">
        {items.length === 0 && !showForm && <div className="text-sm text-[#8A8478]">No casting calls yet.</div>}
        {items.map((c) => (
          <div key={c.casting_id} className="sv-card p-5 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <div className="font-serif-editorial text-lg text-[#F4EFE4]">{c.project} — {c.role}</div>
              <div className="text-xs text-[#8A8478]">{c.location} · {c.shoot_date} · {c.budget}</div>
              <div className="text-[10px] font-mono-label mt-1" style={{ color: c.status === "open" ? "#7BC46B" : "#8A8478" }}>{c.status?.toUpperCase()}</div>
            </div>
            <div className="flex gap-2 flex-wrap">
              {c.status === "open" ? (
                <button onClick={() => close(c.casting_id, "closed")} className="sv-btn-outline text-xs">Close</button>
              ) : (
                <button onClick={() => close(c.casting_id, "open")} className="sv-btn-outline text-xs">Reopen</button>
              )}
              <button onClick={() => del(c.casting_id)} className="sv-btn-outline text-xs inline-flex items-center gap-1"><Trash2 size={12} />Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
